<div class="flex flex-col items-center justify-center mb-12">
  <img src="../../assets/img/icon-usyncro_green-200.png" [alt]="message" class="opacity-30 my-12">
  <span>{{message}}</span>
</div>
